import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImageIcon from 'material-ui/svg-icons/image/image'
import classnames from 'classnames/bind'
import css from './add-image-button.css'

const cx = classnames.bind(css)

export default class AddImageButton extends Component {
  static propTypes = {
    modifier: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    editorState: PropTypes.object.isRequired,
  }

  state = {
    url: '',
    isOpen: false,
  };

  // When the popover is open and users click anywhere on the page,
  // the popover should close
  componentDidMount() {
    document.addEventListener('click', this.closePopover)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closePopover)
  }

  // Note: make sure whenever a click happens within the popover it is not closed
  onPopoverClick = () => {
    this.preventNextClose = true
  }

  openPopover = () => {
    if (!this.state.isOpen) {
      this.preventNextClose = true
      this.setState({
        isOpen: true,
      })
    }
  };

  closePopover = () => {
    if (!this.preventNextClose && this.state.isOpen) {
      this.setState({
        isOpen: false,
      })
    }

    this.preventNextClose = false
  };

  addImage = () => {
    const { editorState, onChange } = this.props
    onChange(this.props.modifier(editorState, this.state.url))
  };

  changeUrl = (evt) => {
    this.setState({ url: evt.target.value })
  }

  render() {
    const { isOpen } = this.state

    const buttonClassName = cx({
      toolbarButtonOpen: isOpen,
      toolbarButton: !isOpen,
    })

    const popoverClassName = cx({
      popover: isOpen,
      popoverClosed: !isOpen,
    })

    return (
      <div className={css.wrapper}>
        <button
          className={buttonClassName}
          onMouseUp={this.openPopover}
          type="button"
        >
          <ImageIcon />
        </button>
        <div
          className={popoverClassName}
          onClick={this.onPopoverClick}
        >
          <input
            type="text"
            placeholder="Paste the image url …"
            className={css.inputUrl}
            onChange={this.changeUrl}
            value={this.state.url}
          />
          <button
            className={css.submit}
            type="button"
            onClick={this.addImage}
          >
            Add
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/AddImageButton.js